import UrlHelper from 'foundation/url-helper';
import ModalTriggerComponent from '../../modal/js/modal-trigger.component';
import { QueryConstants } from '../../../general/js/utils/query-constants';

export default class ModalTriggerLoginComponent extends ModalTriggerComponent {
    getAsyncTargetUrl() {
        const asyncUrl = super.getAsyncTargetUrl();
        const failedReturnUrlParam = this.getAttribute(this.element, 'failed-return-url-param');
        return UrlHelper.getUrlByParams(
            asyncUrl,
            {
                [failedReturnUrlParam]: UrlHelper.getUrlByParams(
                    UrlHelper.getRelativeUrl(window.location), { [QueryConstants.SHOW_POPUP]: UrlHelper.getUrlByParams(asyncUrl, { status: 'LoginFailed' }) }
                )
            }
        );
    }
}
